export default { isPreview: false, data: null };
